<template>
  <div class="border-footer border-footer-top">
    <div class="border-footer-overlay"></div>
  </div>
</template>
  
<script>
  export default {
    name: 'BorderFooterTop'
  }
</script>

<style scoped>
  .border-footer {
    position: relative;
  }

  .border-footer-overlay {
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 4px;
    background-color: black;
    z-index: 2;
  }
</style>